import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { environmentConfigProviderApiRef } from '../api-clients/environmentConfigProvider/EnvironmentConfigProviderApi';
import { EnvironmentConfigProviderClient } from '../api-clients/environmentConfigProvider/EnvironmentConfigProviderClient';

export const environmentConfigProviderApi: AnyApiFactory[] = [
  createApiFactory({
    api: environmentConfigProviderApiRef,
    deps: { configApi: configApiRef, identityApi: identityApiRef },
    factory: ({ configApi, identityApi }) =>
      new EnvironmentConfigProviderClient(configApi, identityApi),
  }),
];
